module.exports = __webpack_public_path__ + "static/sf_11.d7da3c1e.png";